import { render, staticRenderFns } from "./custMainContent.vue?vue&type=template&id=f870f0b0&scoped=true"
import script from "./custMainContent.vue?vue&type=script&lang=js"
export * from "./custMainContent.vue?vue&type=script&lang=js"
import style0 from "./custMainContent.vue?vue&type=style&index=0&id=f870f0b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f870f0b0",
  null
  
)

export default component.exports